import React, { useEffect, useState } from 'react';
import { FlameIcon, ClockIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const COUNTDOWN_SECONDS = 10 * 60;
const STORAGE_KEY = 'pap_offer_deadline';
function getDeadline(): number {
  if (typeof window === 'undefined') return Date.now() + COUNTDOWN_SECONDS * 1000;
  const stored = window.sessionStorage.getItem(STORAGE_KEY);
  if (stored) {
    const ts = parseInt(stored, 10);
    if (!Number.isNaN(ts) && ts > Date.now()) return ts;
  }
  const deadline = Date.now() + COUNTDOWN_SECONDS * 1000;
  window.sessionStorage.setItem(STORAGE_KEY, String(deadline));
  return deadline;
}
export function StickyAlertBar() {
  const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS);
  useEffect(() => {
    const deadline = getDeadline();
    const tick = () => {
      const diff = Math.max(0, Math.round((deadline - Date.now()) / 1000));
      setSecondsLeft(diff);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);
  const minutes = String(Math.floor(secondsLeft / 60)).padStart(2, '0');
  const seconds = String(secondsLeft % 60).padStart(2, '0');
  const items = Array.from({
    length: 6
  });
  return <div className="fixed top-0 left-0 right-0 bg-red-600 text-white py-3 z-50 shadow-lg overflow-hidden" data-id="element-343">
      <motion.div className="flex whitespace-nowrap" animate={{
      x: ['0%', '-50%']
    }} transition={{
      duration: 25,
      ease: 'linear',
      repeat: Infinity
    }} data-id="element-344">
        {[...items, ...items].map((_, i) => <div key={i} className="flex items-center gap-3 px-8 text-base md:text-xl font-bold uppercase tracking-wide" data-id="element-345">
            <span className="flex items-center gap-2" data-id="element-346">
              <ClockIcon className="w-5 h-5 md:w-6 md:h-6 flex-shrink-0" data-id="element-347" />
              Termina en
              <span className="tabular-nums bg-black/25 rounded-md px-2.5 py-0.5 tracking-widest" data-id="element-348">
                {minutes}:{seconds}
              </span>
            </span>
            <span className="opacity-60" data-id="element-349">·</span>
            <span className="flex items-center gap-2" data-id="element-350">
              <FlameIcon className="w-5 h-5 md:w-6 md:h-6 flex-shrink-0" data-id="element-351" />
              50% OFF
            </span>
            <span className="opacity-60" data-id="element-352">·</span>
            <span data-id="element-353">Acceso inmediato</span>
          </div>)}
      </motion.div>
    </div>;
}